<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('filesMedia', [
      'files',
      'mediaBusy',
      'hasNextToken'
    ])
  },

  methods: {
    ...mapActions('filesMedia', [
      'getFiles',
      'getUpdates'
    ])
  }
}
</script>
